import { render, staticRenderFns } from "./AS_RechargePrepaidold.vue?vue&type=template&id=667bd702&scoped=true&"
import script from "./AS_RechargePrepaidold.vue?vue&type=script&lang=js&"
export * from "./AS_RechargePrepaidold.vue?vue&type=script&lang=js&"
import style0 from "./AS_RechargePrepaidold.vue?vue&type=style&index=0&id=667bd702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bd702",
  null
  
)

export default component.exports